import React from 'react';
import { Typography } from 'views/components/atoms/Typography';
import { Color } from 'views/constants';
import styled from '@emotion/styled';

interface WrapperProps {
  maxWidth?: string;
}

const Wrapper = styled.div<WrapperProps>`
  max-width: ${({ maxWidth }): string => (maxWidth ? maxWidth : 'initial')};
  text-align: center;
`;

interface InfoMessagesProps {
  message: string;
  maxWidth?: string;
}

export const InfoMessage: React.FC<InfoMessagesProps> = ({
  message,
  maxWidth,
}) => (
  <Wrapper maxWidth={maxWidth}>
    <Typography el="p" color={Color.C9} block>
      {message}
    </Typography>
  </Wrapper>
);
